"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachedFileTitle = void 0;
const react_1 = __importDefault(require("react"));
const Text_1 = require("../../../../Text/Text");
const ComposeContext_1 = require("../../ComposeContext");
const AttachedFileTitle = ({ customTitleDisplay, }) => {
    var _a;
    const { uploadedFiles } = (0, ComposeContext_1.useCompose)();
    let customTitleDisplayNodeType = ""; // Identify the type of custom render
    if (customTitleDisplay === null || customTitleDisplay === void 0 ? void 0 : customTitleDisplay.type) {
        customTitleDisplayNodeType =
            typeof customTitleDisplay.type === "string"
                ? customTitleDisplay.type
                : (_a = customTitleDisplay.type.displayName) !== null && _a !== void 0 ? _a : customTitleDisplay.type.name;
    }
    // Check accepted custom button type - semantic paragraph, semantic span, accurx design lib Text
    if (customTitleDisplay &&
        !(customTitleDisplayNodeType === "p" ||
            customTitleDisplayNodeType === "span" ||
            customTitleDisplay.type === "h1" ||
            customTitleDisplay.type === "h2" ||
            customTitleDisplay.type === "h3" ||
            customTitleDisplayNodeType === "Text")) {
        throw new Error("Only a textual element can be passed as a custom render to Compose.AttachedFileTitle");
    }
    if (uploadedFiles.length === 0) {
        return null;
    }
    if (customTitleDisplay) {
        return customTitleDisplay;
    }
    return react_1.default.createElement(Text_1.Text, { variant: "label" }, "Attachments");
};
exports.AttachedFileTitle = AttachedFileTitle;
//# sourceMappingURL=AttachedFileTitle.js.map